import React from 'react';
import ColorIndicator from 'UI/components/atoms/ColorIndicator';
import { MarkerCompanyClass, MarkerTypeClass } from 'UI/constants/defaults';
import { EntityType } from 'UI/constants/entityTypes';

import { useStyles } from './MapEntityStatus.styled';

export const MapEntityStatus = ({ markerType, entity, type }) => {
  const classes = useStyles();

  const isCompany = entity === EntityType.Company;

  const mapMarkerClass = !isCompany ? MarkerTypeClass[markerType] : MarkerCompanyClass[markerType];

  return (
    <>
      <ColorIndicator customClass={`map-marker-sm ${mapMarkerClass}`} />
      <span className={classes.itemType}>{type}</span>
    </>
  );
};
